const Preference = {
  
  saveLastLoginType(type){
    localStorage['last-login-type'] = type;
  },
  getLastLoginType(){
    if (localStorage["last-login-type"] == null){
      return ''
    }else{
      return localStorage["last-login-type"]
    }
  },
  
  savePhoneAccount(phone) {
    localStorage['login-phone'] = phone;
  },
  getPhoneAccount() {
    if(localStorage['login-phone'] == null){
      return ''
    }else{
      return localStorage['login-phone']
    }
  },
  
  savePhonePwd(pwd) {
    localStorage['login-pwd'] = pwd;
  },
  getPhonePwd() {
    if(localStorage['login-pwd'] == null){
      return ''
    }else{
      return localStorage['login-pwd']
    }
  },
  
  saveWeChatAccount(){
  
  },
  getWeChatAccount(){
  
  },
  saveOwnInfo(data){
    try{
      localStorage["owninfo"] = JSON.stringify(data);
    }catch (e) {
      console.error(e)
    }
  },
  getOwnInfo(){
    let obj = {}
    let data = localStorage["owninfo"];
    try {
      if (data != null && data.length > 0) {
        obj = JSON.parse(data);
      }
    } catch (err) {
      console.log(err)
    }
    return obj;
  },
  
  getBrowserIMEI(){
    if(localStorage["BrowserIMEI"] == null || localStorage["BrowserIMEI"] == ''){
      let timestamp = Date.parse(new Date()) + Math.ceil(Math.random()*1000)
      localStorage["BrowserIMEI"] = timestamp
      return timestamp
    }else{
      return localStorage["BrowserIMEI"]
    }
  },
  
  
  //**********最后一次对话信息***********//
  setLastDialogueInfo(detail){
    try{
      localStorage["last-dialogue-info"] = JSON.stringify(detail);
    }catch (e) {
      console.error(e)
    }
  },
  
  getLastDialogueInfo(){
    let obj = {}
    let data = localStorage["last-dialogue-info"];
    try {
      if (data != null && data.length > 0) {
        obj = JSON.parse(data);
      }
    } catch (err) {
      console.log(err)
    }
    return obj;
  },
  
  //**********最后一次订单信息***********//
  setLastOrderDetailInfo(detail){
    try{
      localStorage["last-order-detail-info"] = JSON.stringify(detail);
    }catch (e) {
      console.error(e)
    }
  },
  
  getLastOrderDetailInfo(){
    let obj = {}
    let data = localStorage["last-order-detail-info"];
    try {
      if (data != null && data.length > 0) {
        obj = JSON.parse(data);
      }
    } catch (err) {
      console.log(err)
    }
    return obj;
  },
  
  //**********好友列表***********//
  setFriendList(data){
    try{
      localStorage["friend-list"] = JSON.stringify(data);
    }catch (e) {
      console.error(e)
    }
  },
  getFriendList(){
    try {
      let data = localStorage["friend-list"];
      if (data != null && data.length > 0) {
        return JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return [];
  },
  //**********好友请求列表***********//
  setFriReqList(data){
    try{
      localStorage["fri-req-list"] = JSON.stringify(data);
    }catch (e) {
      console.error(e)
    }
  },
  getFriReqList(){
    try {
      let data = localStorage["fri-req-list"];
      if (data != null && data.length > 0) {
        return JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return [];
  },
  
  //**********黑名单列表***********//
  setRefuseList(data){
    try{
      localStorage["refuse-list"] = JSON.stringify(data);
    }catch (e) {
      console.error(e)
    }
  },
  getRefuseList(){
    try {
      let data = localStorage["refuse-list"];
      if (data != null && data.length > 0) {
        return JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return [];
  },
  //**********聊天列表***********//
  setDialogueList(data, id){
    try{
      localStorage["dialogue-list" + id] = JSON.stringify(data);
    }catch (e) {
      console.error(e)
    }
  },
  getDialogueList(id){
    try {
      let data = localStorage["dialogue-list" + id];
      if (data != null && data.length > 0) {
        return JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return [];
  },
  
  setLocation(location){
    try{
      localStorage["baidu-location"] = JSON.stringify(location);
    }catch (e) {
      console.error(e)
    }
  },
  getLocation(){
    try {
      let data = localStorage["baidu-location"];
      if (data != null && data.length > 0) {
        return JSON.parse(data)
      }
    } catch (err) {
      console.log(err)
    }
    return {lng: 116.403119, lat: 39.917813, city: '北京市', addr: ''};
  },
  
  
  setH5Ver(ver){
    try{
      localStorage["h5-ver"] = ver;
    }catch (e) {
      console.error(e)
    }
  },
  getH5Ver(){
    try {
      let data = localStorage["h5-ver"];
      if (data != null && data.length > 0) {
        return data
      }
    } catch (err) {
      console.log(err)
    }
    return '0.0';
  }
}

Preference.install = function (Vue, options) {
  Vue.prototype.$preference = Preference
}

export default Preference;



// WEBPACK FOOTER //
// ./src/plugins/preference.js